/* eslint-disable no-continue, guard-for-in, no-restricted-syntax */
import { constant } from "@daytrip/legacy-config";
import { Container } from "inversify";
import getDecorators from "inversify-inject-decorators";

export { constant };
export const container = new Container({ skipBaseClassChecks: true });
export const { lazyInject } = getDecorators(container);
